import type { Platform, Language } from '@/types/common';
import type { VideoResolution, AspectRatio } from '@/types/content';
import type { ArchetypeSlug } from '@/types/persona';

// Posting, engagement scraping, and account linking are Instagram-only today;
// the other `Platform` values exist in the type but have no pipeline behind
// them, so the picker offers only what actually works.
export const PLATFORM_OPTIONS: Platform[] = ['instagram'];
export const LANGUAGE_OPTIONS: Language[] = ['en', 'es'];
export const RESOLUTION_OPTIONS: VideoResolution[] = ['480p', '720p', '1080p'];
export const ASPECT_RATIO_OPTIONS: AspectRatio[] = ['9:16', '16:9', '1:1', '4:3', '3:4'];

// Fallback only — the trigger form snaps to the first archetype `GET
// /archetypes` returns for the active niche once it loads.
export const DEFAULT_ARCHETYPE: ArchetypeSlug = 'fitness_coach';
export const DEFAULT_PLATFORM: Platform = 'instagram';
export const DEFAULT_LANGUAGE: Language = 'en';
export const DEFAULT_AVATAR_REFS = 1;

export const DEFAULT_RESOLUTION: VideoResolution = '720p';
export const DEFAULT_ASPECT_RATIO: AspectRatio = '9:16';

// Every content run is fixed at 20s (4x 5s Kling segments concatenated).
export const FIXED_VIDEO_DURATION_SEC = 20;
export const CONTENT_GEN_COST_PREVIEW = {
  cost_usd: 2.5,
  duration_sec: FIXED_VIDEO_DURATION_SEC,
  currency: 'USD',
  summary: 'Generates a 20-second video (Claude script + 4× Kling 5s segments).',
} as const;
export const AVATAR_REFS_MIN = 1;
export const AVATAR_REFS_MAX = 9;

export const TRIGGERS_PERSONAS_LIMIT = 500;

// Niche is deployment-selected (`GHOST_ACTIVE_NICHE`), never a trait; the
// worker drops both keys if a caller sends them.
export const RESERVED_TRAIT_KEYS = new Set(['sport', 'niche']);

// Sponsored product: last-used product is remembered per browser so the
// operator doesn't re-upload the packshot for every post.
export const LAST_PRODUCT_STORAGE_KEY = 'ghost.triggerContent.lastProduct';
